import { useEffect, useRef } from "react";
import { useUserStore, useAmlCheckStore } from "@/store";
import { useNavigate } from "react-router";
import { PAGES } from "@/config/pages";
import { Layout, StateInfoBox } from "@/components";

const AmlCheck = () => {
  const navigate = useNavigate();
  const balance = useUserStore((state) => state.user.balance);
  const {
    hasAmlInputs,
    amlExplore,
    errorCode,
    clearAmlError,
    isLoading,
    amlError,
  } = useAmlCheckStore();
  const isProcessing = useRef(false);

  useEffect(() => {
    const handleAmlExplore = async () => {
      if (isProcessing.current || isLoading) {
        return;
      }

      if (balance > 0 && hasAmlInputs) {
        isProcessing.current = true;
        const amlItemId = await amlExplore();

        if (amlItemId) {
          navigate(PAGES.AML_CHECK_DETAILS, { state: { itemId: amlItemId } });
        } else {
          if (errorCode) {
            const message = amlError;
            clearAmlError();

            navigate(PAGES.ERROR_PAGE, {
              state: {
                message:
                  message ||
                  "The provided data is invalid. Please try new check.",
              },
            });
          } else {
            navigate(PAGES.ERROR_PAGE, {
              state: {
                message: "The provided data is invalid. Please try new check.",
              },
            });
          }
        }
      } else {
        navigate(PAGES.HOME);
      }
    };

    handleAmlExplore();
  }, [
    balance,
    hasAmlInputs,
    amlExplore,
    navigate,
    isLoading,
    errorCode,
    amlError,
    clearAmlError,
  ]);

  useEffect(() => {
    if (errorCode) {
      const message = amlError;
      clearAmlError();

      navigate(PAGES.ERROR_PAGE, {
        state: {
          message: message || "The provided data is invalid. Please try again.",
        },
      });
    }
  }, [errorCode, navigate, clearAmlError, amlError]);

  return (
    <Layout title="Initiating AML check...">
      <StateInfoBox type="loading" />
    </Layout>
  );
};

export default AmlCheck;
